<script>
import { isString } from '../utils'

export default {
  props: ['to', 'params', 'id'],
  computed: {
    _params() {
      const params = {
        ...(this.params || {}),
      }

      if (this.id) params.id = this.id

      return params
    },
    route() {
      if (!isString(this.to)) return this.to

      return {
        name: this.to,
        params: this._params,
      }
    },
  },
  methods: {
    go() {
      if (this.to) {
        if (isString(this.to) && this.to.includes('http')) {
          location.href = this.to
        } else {
          this.$router.push(this.route)
        }
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/mixins/Link.vue